import { onMounted } from "vue";
import { useApi } from "@api/integration";
import { useIntl } from "@services/i18n";
import { useModalService } from "@services/modal-service";
import { lgModalPopupProps } from "@helpers/modal-helper";
import ComunicadoPrevisualizacion from "@components/comunicados/ComunicadoPrevisualizacion.vue";
import { ComunicadoPrevisualizacionModel } from "@components/comunicados/models/ComunicadoPrevisualizacionModel";

export function useComunicadosPortalSinLeer() {
  const api = useApi();
  const intl = useIntl();
  const modal = useModalService();

  async function mostrarComunicadosSinLeer() {
    let ids: string[];

    try {
      ids = await api.callStandardApi("getComunicadosPortalSinLeerForColaborador", { showLoading: false });
    } catch (error) {
      console.error("Error al obtener comunicados de portal sin leer:", error);
      return;
    }

    if (!ids?.length) {
      return;
    }

    const title = intl.i18n.t("comunicados.previsualizacion.titulo_nuevo") ;

    for (const id of ids) {
      try {
        const detail = await api.callStandardApi("getComunicadoDetailForColaborador", { showLoading: true }, id);
        await modal.showModal(
          ComunicadoPrevisualizacion,
          { model: ComunicadoPrevisualizacionModel.fromApi(detail) },
          { ...lgModalPopupProps, title },
        );
        await api.callStandardApi("readComunicadoForColaborador", { showLoading: false }, id);
      } catch (error) {
        console.error(`Error al mostrar o marcar como leído el comunicado ${id}:`, error);
      }
    }
  }

  onMounted(() => {
    void mostrarComunicadosSinLeer();
  });
}
